import React from 'react';

import FormLogin from '../forms/FormLogin.jsx';
import meta from '~/commons/config/meta';

const PageLogin = () => {
  meta.set({ title: 'Login' });

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-4">
          <FormLogin />
        </div>
      </div>
    </div>
  );
};

export default PageLogin;
